import {
  Alert,
  FormCheckbox,
  FormDropDownList,
  FormNumericTextBox,
  FormRadioGroupChange,
} from "@mikros/shared-ui";
import { Field, FormRenderProps } from "@progress/kendo-react-form";
import { useEffect, useRef, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GenerateChapters } from "./generateChapters/generateChapters";

import {
  CourseModuleCards,
  GenerativeAiChapters,
  GenerativeAiRequestCards,
} from "@mikros/library";
import { FormattedMessage, useIntl } from "react-intl";
import ApiServices from "../../../service/apiService";
import { events } from "aws-amplify/api";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import AuthService from "../../../service/authService";
import { jwtDecode } from "jwt-decode";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useNavigate } from "react-router-dom";

export interface GenerativeAiProps {
  duplicateS3File: (
    sourceKey: string,
    destinationKey: string,
    fileType: string
  ) => void;
  handleUploadGiveUrl: (e: CourseModuleCards) => void;
  handleUpdateStatusRev: (
    status: string,
    course: CourseModuleCards
  ) => Promise<boolean>;
  handleUpdateStatusAll: (
    status: string,
    course?: CourseModuleCards
  ) => Promise<boolean>;

  formRenderProps: FormRenderProps;
  changeState: boolean;
  chapters: GenerativeAiChapters;
  cards: CourseModuleCards;
  handleState: () => void;
  handleAIChapterCardChange: (course: CourseModuleCards) => Promise<boolean>;
  handleRequestCard: (e: GenerativeAiRequestCards, nav: boolean) => void;
  changeToCardState: boolean;
}

export function GenerativeAi(props: GenerativeAiProps) {
  const intl = useIntl();
  const navigate = useNavigate()

  //sub state and ref
  const subRef = useRef<any>(null);
  const [sub, setSub] = useState<any>(null);

  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();

  useEffect(() => {
    async function fetchSub() {
      let a = await AuthService.getInstance().getIdToken();
      console.log("id token course", a);
      const decoded: any = jwtDecode(a);
      const subValue = decoded["sub"];
      setSub(subValue);
      subRef.current = subValue;
      console.log("print tenant id inside use effect of edit course", subValue);
    }
    fetchSub();
  }, []);

  const assessmentRadioData = [
    {
      label: intl.formatMessage({
        id: "courses.generativeAi.courseOptions.assessment.option1",
      }),
      value: true,
    },
    {
      label: intl.formatMessage({
        id: "courses.generativeAi.courseOptions.assessment.option2",
      }),
      value: false,
    },
  ];
  const summaryRadioData = [
    {
      label: intl.formatMessage({
        id: "courses.generativeAi.courseOptions.summary.option1",
      }),
      value: true,
    },

    {
      label: intl.formatMessage({
        id: "courses.generativeAi.courseOptions.summary.option2",
      }),
      value: false,
    },
  ];

  const courseLevelData = [
    intl.formatMessage({
      id: "courses.generativeAi.courseLevel.beginner",
    }),
    intl.formatMessage({
      id: "courses.generativeAi.courseLevel.intermediate",
    }),
    intl.formatMessage({
      id: "courses.generativeAi.courseLevel.advanced",
    }),
    intl.formatMessage({
      id: "courses.generativeAi.courseLevel.expert",
    }),
  ];

  const [assessmentIncluded, setAssessmentIncluded] = useState<boolean>(false);
  const [summaryIncluded, setSummaryIncluded] = useState<boolean>(false);

  //Error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  // const handleAudioGeneration = async (e: any): Promise<string | false> => {
  //   console.log("Inside handle audio generation of generative ai", e);

  //   const body = {
  //     courseId: e.courseId,
  //     chapterId: e.chapterId,
  //     cardId: e.cardId,
  //     accntId: accountInstance.accntId,
  //     createdBy: e.createdBy,
  //     prompt: e.prompt,
  //     cardType: e.cardType,
  //     language: e.language,
  //     languageCode: e.languageCode,
  //     style: e.style,
  //     voiceName: e.voiceName,
  //   };
  //   const accntId = body.accntId;
  //   const courseId = body.courseId;

  //   const endpoint = `${accntId}/course/${courseId}/genAudio`;
  //   const api = ApiServices.getInstance();

  //   if (!accntId) {
  //     return false;
  //   }
  //   try {
  //     const res = await api.makeRequest(endpoint, "POST", body);
  //     if (res && res.errorMessage) {
  //       setErrorFlag(true);
  //       if (errorInstance && errorInstance.updateErrorCode) {
  //         await errorInstance.updateErrorCode(res.errorMessage);
  //       }
  //       console.log("audio error response", res);
  //       return false;
  //     }
  //     console.log("Audio generation API response", res);
  //     const parsedBody = JSON.parse(res.body);
  //     const presignedUrl = parsedBody.presignedUrl;
  //     console.log("Presigned url audio being sent in create", presignedUrl);
  //     return presignedUrl;
  //   } catch (err) {
  //     console.error("Error in handle audio gen", err);
  //     setErrorFlag(true);
  //     if (errorInstance && errorInstance.updateErrorCode) {
  //       await errorInstance.updateErrorCode("Audio gen failed");
  //     }
  //     return false;
  //   }
  // };


  const handleAudioGeneration = async (
    e: any
  ): Promise<{ presignedUrl: string; prompt: string } | false> => {
    console.log("Inside handle audio generation of create course", e);
  
    const body = {
      courseId: e.courseId,
      chapterId: e.chapterId,
      cardId: e.cardId,
      accntId: accountInstance.accntId,
      createdBy: e.createdBy,
      prompt: e.prompt,
      cardType: e.cardType,
      language: e.language,
      languageCode: e.languageCode,
      style: e.style,
      voiceName: e.voiceName,
    };
    const accntId = body.accntId;
    const courseId = body.courseId;
  
    const endpoint = `${accntId}/course/${courseId}/genAudio`;
    const api = ApiServices.getInstance();
  
    if (!accntId) {
      return false;
    }
    try {
      const res = await api.makeRequest(endpoint, "POST", body);
      if (res && res.errorMessage) {
        setErrorFlag(true);
        if (errorInstance && errorInstance.updateErrorCode) {
          await errorInstance.updateErrorCode(res.errorMessage);
        }
        console.log("audio error response", res);
        return false;
      }
      console.log("Audio generation API response", res);
      const parsedBody = JSON.parse(res.body);
  
      const presignedUrl = parsedBody.presignedUrl;
      const prompt = parsedBody.prompt; // extract prompt
  
      console.log("Prompt returned in create", prompt);
      console.log("Presigned url audio being sent in create", presignedUrl);
  
  
      return { presignedUrl, prompt };
    } catch (err) {
      console.error("Error in handle audio gen", err);
      setErrorFlag(true);
      if (errorInstance && errorInstance.updateErrorCode) {
        await errorInstance.updateErrorCode("Audio gen failed");
      }
      return false;
    }
  };


  const handleVideoGeneration = async (e: any): Promise<any> => {
    console.log("inside handle video generation of edit course", e);

    const body = {
      courseName: e.courseName,
      chapterName: e.chapterName,
      courseId: e.courseId,
      chapterId: e.chapterId,
      cardId: e.cardId,
      accntId: accountInstance.accntId,
      createdBy: e.createdBy,
      prompt: e.prompt,
      userId: subRef.current,
      cardType: e.cardType,
    };
    console.log("body in edit course handle video generation", body);

    const accntId = body.accntId;
    const courseId = body.courseId;

    const endpoint = `${accntId}/course/${courseId}/genVideo`;

    const api = ApiServices.getInstance();

    if (accntId) {
      return await api
        .makeRequest(endpoint, "POST", body)
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            if (errorInstance && errorInstance.updateErrorCode) {
              await errorInstance.updateErrorCode(res.errorMessage);
            }
            return false;
          }
          console.log("Video generation response:", res);
          return res;
        })
        .catch(async (err) => {
          setErrorFlag(true);
          if (errorInstance && errorInstance.updateErrorCode) {
            await errorInstance.updateErrorCode("Video generation failed");
          }
          return false;
        });
    } else {
      return false;
    }
  };
  const handleImageGeneration = async (e: any): Promise<string | false> => {
    console.log(
      "inside handle image generation of create course of generate chapters",
      e
    );

    const body = {
      courseId: e.courseId,
      chapterId: e.chapterId,
      cardId: e.cardId,
      accntId: accountInstance.accntId,
      createdBy: e.createdBy,
      prompt: e.prompt,
      cardType: e.cardType,
    };

    const accntId = body.accntId;
    const courseId = body.courseId;
    // const endpoint = `${accntId}/course/${courseId}/genMedia`;
    const endpoint = `${accntId}/course/${courseId}/genImage`;
    const api = ApiServices.getInstance();

    if (!accntId) return false;

    const channelPath = `/default/${body.cardId}`;

    try {
      console.log("Connecting to:", channelPath);
      const channel = await events.connect(channelPath);
      console.log("Connected to channel:", channel);

      const presignedUrl: string = await new Promise((resolve, reject) => {
        channel.subscribe({
          next: (data) => {
            console.log("Received data from channel subscription", data);
            try {
              // ONLY parse if it’s still a JSON string
              const eventData =
                typeof data.event === "string"
                  ? JSON.parse(data.event)
                  : data.event;

              const url = eventData?.presignedUrl;
              if (!url) throw new Error("presignedUrl missing");

              console.log("Presigned URL:", url);
              resolve(url);
            } catch (err) {
              reject("Failed to extract presignedUrl: " + err);
            }
          },
          error: (err) => {
            console.error("Error in channel subscription", err);
            // setLoading(false);
            // spinner.hideSpinner();
            reject("Channel subscription error");
          },
        });

        console.log(
          "Subscribed to channel. Now sending video generation request..."
        );

        // Fire API after subscription starts listening
        api.makeRequest(endpoint, "POST", body).then((res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            if (errorInstance && errorInstance.updateErrorCode) {
              errorInstance.updateErrorCode(res.errorMessage);
            }
            // spinner.hideSpinner();
            // setLoading(false);
            reject("API returned error");
          }
          console.log("Image generation API response:", res);
        });
      });
      // setLoading(false);
      // spinner.hideSpinner();
      return presignedUrl;
    } catch (err) {
      console.error("Error in handleImageGeneration:", err);
      // spinner.hideSpinner();
      // setLoading(false);
      setErrorFlag(true);
      if (errorInstance && errorInstance.updateErrorCode) {
        await errorInstance.updateErrorCode("Image generation failed");
      }
      return false;
    }

    return false;
  };
  const handleAssessmentIncludedChange = (event: any) => {
    setAssessmentIncluded(event.value);
    if (!event.value) {
      props.formRenderProps.onChange("assessmentEnd", { value: null });
    }
  };

  const handleSummaryIncludedChange = (event: any) => {
    setSummaryIncluded(event.value);
    if (!event.value) {
      props.formRenderProps.onChange("summaryEnd", {
        value: null,
      });
    }
  };

  const validator = {
    courseLevel: (value: DropDownList) =>
      !value
        ? intl.formatMessage({
            id: "courses.generativeAi.courseLevelValidator",
          })
        : "",
    chapterCnt: (value: number) =>
      !value
        ? intl.formatMessage({
            id: "courses.generativeAi.chapterCnt",
          })
        : "",
  };

  return (
    <div className="flex flex-col">
         {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              navigate("/courses");
            }}
          />
        </Dialog>
      )}
      {props.changeState === false ? (
        <div>
          <Field
            name={"courseLevel"}
            id={"courseLevel"}
            label={
              <strong>
                <FormattedMessage id="courses.generativeAi.courseLevel" />
              </strong>
            }
            component={FormDropDownList}
            // defaultValue=""
            validator={validator.courseLevel}
            className="bg-white w-[15%] "
            data={courseLevelData}
          />

          <Field
            name="chapterCnt"
            id="chapterCnt"
            label={
              <div className="flex items-baseline">
                <strong>
                  <FormattedMessage id="courses.generativeAi.chapterCount" />{" "}
                </strong>
                <div className="text-[10px] pl-1">
                  <FormattedMessage id="courses.generativeAi.chapterCount.optional" />
                </div>{" "}
              </div>
            }
            component={FormNumericTextBox}
            validator={validator.chapterCnt}
            min={5}
            max={20}
            hint={
              <div className="text-[10px]">
                <FormattedMessage id="courses.generativeAi.chapterCount.minimum" />
              </div>
            }
            className="w-[7%]"
          />

          <div className="flex flex-col space-y-2 pt-4">
            <div className="font-bold">
              <FormattedMessage id="courses.generativeAi.courseOptions" />
            </div>
            <Field
              name={"assessment"}
              id={"assessment"}
              label={
                <strong>
                  <FormattedMessage id="courses.generativeAi.courseOptions.assessment" />
                </strong>
              }
              component={FormCheckbox}
              onChange={handleAssessmentIncludedChange}
              className=" w-[15%]"
            />
            <Field
              name={"assessmentEnd"}
              id={"assessmentEnd"}
              component={FormRadioGroupChange}
              disabled={!assessmentIncluded}
              className="ps-8"
              data={assessmentRadioData}
            />
          </div>

          <div className="flex flex-col space-y-1">
            <Field
              name={"summary"}
              id={"summary"}
              label={
                <strong>
                  <FormattedMessage id="courses.generativeAi.courseOptions.summary" />
                </strong>
              }
              component={FormCheckbox}
              onChange={handleSummaryIncludedChange}
              className=" w-[15%]"
            />
            <Field
              name={"summaryEnd"}
              id={"summaryEnd"}
              component={FormRadioGroupChange}
              disabled={!summaryIncluded}
              className="ps-8"
              data={summaryRadioData}
            />
          </div>
        </div>
      ) : (
        <GenerateChapters
          handleUpdateStatusAll={(
            status: string,
            course?: CourseModuleCards
          ): Promise<boolean> => {
            return props.handleUpdateStatusAll(status, course);
          }}
          handleUpdateStatusRev={(
            status: string,
            course: CourseModuleCards
          ): Promise<boolean> => {
            return props.handleUpdateStatusRev(status, course);
          }}
          handleUploadGiveUrl={(e: CourseModuleCards) => {
            return props.handleUploadGiveUrl(e);
          }}
          duplicateS3File={(
            sourceKey: string,
            destinationKey: string,
            fileType: string
          ) => {
            return props.duplicateS3File(sourceKey, destinationKey, fileType);
          }}
          handleState={() => props.handleState()}
          chapters={props.chapters}
          changeToCardState={props.changeToCardState}
          handleRequestCards={(e: GenerativeAiRequestCards, nav?: boolean) =>
            props.handleRequestCard(e, nav!!)
          }
          handleAIChapterCardChange={(
            course: CourseModuleCards
          ): Promise<boolean> => {
            return props.handleAIChapterCardChange(course);
          }}
          cards={props.cards}
          handleVideoGeneration={handleVideoGeneration}
          handleImageGeneration={handleImageGeneration}
          handleAudioGeneration={handleAudioGeneration}
        />
      )}
    </div>
  );
}
